import { FacetService } from '@spartacus/storefront';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject, combineLatest } from 'rxjs';
import {
  HiddenSearchBreadcrumbFacets,
  HiddenCategoryBreadcrumbFacets,
} from '@app/custom/features/rrs-product-listing/model';
import { RrsProductFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-product-facet-service.service';
import { RoutingService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { isArray } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class RrsFacetService extends FacetService {
  productFacetService = inject(RrsProductFacetService);
  routingService = inject(RoutingService);

  mobileDialogSelectedFacets$ = new BehaviorSubject({});
  getLinkParams(query: string): Params {
    let filtersQuery = super.getLinkParams(query).query;
    if (filtersQuery?.length) {
      filtersQuery = encodeURIComponent(filtersQuery);
    }
    return {
      facetFilters: filtersQuery?.length ? filtersQuery : null,
      currentPage: 0,
    };
  }

  getTranslationKey(facetName: string): string {
    return `rrs.facet.${facetName}`;
  }

  shouldHideFacet(facetName: string, url: string): boolean {
    const hiddenBreadcrumbFacets = url.includes('/search')
      ? HiddenSearchBreadcrumbFacets
      : HiddenCategoryBreadcrumbFacets;

    return (hiddenBreadcrumbFacets as Array<string>).includes(facetName);
  }

  getFacetData(): any {
    return combineLatest([
      this.productFacetService.result$,
      this.routingService.getRouterState(),
    ]).pipe(
      map(([resultPage, routerState]) => {
        return {
          facets: resultPage.facets,
          activeFacets: resultPage.breadcrumbs?.filter(
            (facet) =>
              !this.shouldHideFacet(
                facet.facetName ?? '',
                routerState.state.url
              )
          ),
          currentSearchQuery: resultPage.currentQuery?.query?.value ?? '',
        };
      })
    );
  }
  initialMobileFacets(): void {
    this.getFacetData()
      .subscribe((facetData: any) => {
        const mobileSelectedFacetData: any = {};
        facetData.activeFacets?.forEach((res: any) => {
          if (res.facetName) {
            if (!isArray(mobileSelectedFacetData[res.facetName])) {
              mobileSelectedFacetData[res.facetName] = [];
            }
            mobileSelectedFacetData[res.facetName].push(res.facetValueName);
          }
        });
        this.mobileDialogSelectedFacets$.next(mobileSelectedFacetData);
      })
      .unsubscribe();
  }
}
